export class ConfirmationStatus {

    static PENDING = "PENDING";
    static APPROVED = "APPROVED";
}

export class Email {

    constructor(data) {

        this.email = data.email;
        this.status = data.status; // ConfirmationStatus
        this.primary = data.primary;
    }
}